export default function ContactInfo() {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            뉴테크 연락처
          </h2>
          <p className="text-lg opacity-90">
            레이저 가공 전문 뉴테크로 문의하세요
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/15 transition-colors">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-500 text-slate-900 rounded-full mx-auto mb-4">
              <i className="ri-phone-fill text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">전화 문의</h3>
            <a
              href="tel:02-2261-2017"
              className="text-2xl font-bold text-amber-500 hover:text-amber-400 transition-colors cursor-pointer"
            >
              02-2261-2017
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/15 transition-colors">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-500 text-slate-900 rounded-full mx-auto mb-4">
              <i className="ri-mail-fill text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">이메일</h3>
            <a
              href="mailto:nt2017@daum.net"
              className="text-xl font-semibold text-amber-500 hover:text-amber-400 transition-colors cursor-pointer break-all"
            >
              nt2017@daum.net
            </a>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center hover:bg-white/15 transition-colors">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-500 text-slate-900 rounded-full mx-auto mb-4">
              <i className="ri-map-pin-fill text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">주소</h3>
            <p className="text-base opacity-90 leading-relaxed">
              서울특별시 중구<br />
              을지로27가길 3<br />
              중앙프라자 1층 4호
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
